import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-edit',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
	exact: true,
	query: ['config?'],
};
